<template>
  <v-app>
    <app-header></app-header>
    <v-content class="contentArea">
      <v-container fluid>
        <app-form
                @filteredData="results"
                :firstUniversity="firstUniversity"
                :firstUniversityText="firstUni"
                :ranking="ranking"
        ></app-form>
        <app-table
                v-if="data.length > 0"
                :tableData="data"
                :firstUniversity="firstUniversity"
                :firstUniversityText="firstUni"
                :ranking="ranking"
        ></app-table>
        <app-footer v-if="data.length > 0"></app-footer>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import AppForm from "@/components/AppForm";
import AppTable from "@/components/AppTable";
import AppHeader from "@/components/AppHeader";
import AppFooter from "@/components/AppFooter";

export default {
  name: "App",
  components: {
    AppForm,
    AppTable,
    AppHeader,
    AppFooter
  },
  data: () => ({
    data: [],
    firstUni: "ÜSKÜDAR ÜNİVERSİTESİ (İSTANBUL)"
  }),
  methods: {
    results(results) {
      this.data = results;
    },
    firstUniversity: (arr, key) => {
      let newArr = arr;
      let selected = null;
      arr.forEach((res, index) => {
        if (res.universite == key) {
          newArr.splice(index, 1);
          selected = res;
        }
      });
      if (selected) {
        newArr.unshift(selected);
      }
      return newArr;
    },
    ranking(arr, key) {
      let res = arr.sort((a, b) => {
        return b[key] - a[key];
      });
      return res;
    },
  }
};
</script>

<style>
body {
  background-image: url("assets/bg.jpg");
  background-size: 100%;
  background-attachment: fixed;
}
.v-application.theme--light {
  background: none !important;
}
.contentArea {
  width: 94%;
  margin: 0 auto;
}

@media only screen and (max-width: 1500px) {
    .contentArea {
        width: 99%;
    }
}
@media only screen and (max-width: 1300px) {
    .contentArea {
        width: 100%;
    }
}
</style>
